module.exports = __webpack_public_path__ + "img/40_38_063_310.778afe57.jpg";